import { RootState } from '@client/redux/types';
import { NAMESPACE } from './constants';

export const getSubscriptions = (state: RootState) => state[NAMESPACE].subscriptions;
export const getConsentStatus = (state: RootState) => state[NAMESPACE].consentStatus;
export const getSubscriptionLoading = (state: RootState) => state[NAMESPACE].subscriptionLoading;
export const getConsentLoading = (state: RootState) => state[NAMESPACE].consentLoading;
export const getNewsletterSubscriptionPending = (state: RootState) =>
    state[NAMESPACE].subscriptionPending;
export const getNewsletterErrorCount = (state: RootState) => state[NAMESPACE].errorCount;
export const getNewsletterError = (state: RootState) => state[NAMESPACE].error;
export const getNewlySubscribed = (state: RootState) => state[NAMESPACE].newlySubscribed;
